import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMail, FiTwitter, FiLinkedin, FiGithub } = FiIcons;

const Footer = () => {
  const { t } = useTranslation();
  
  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ y: 30, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="flex flex-col items-center text-center"
        >
          <div className="flex items-center mb-6">
            <span className="text-2xl font-bold text-white">CookiePal</span>
          </div>
          <p className="text-gray-400 leading-relaxed mb-6 max-w-2xl">
            {t('footer.description')}
          </p>
          <div className="flex space-x-4 mb-8">
            <SafeIcon icon={FiTwitter} className="text-xl text-gray-400 hover:text-blue-400 cursor-pointer transition-colors" />
            <SafeIcon icon={FiLinkedin} className="text-xl text-gray-400 hover:text-blue-400 cursor-pointer transition-colors" />
            <SafeIcon icon={FiGithub} className="text-xl text-gray-400 hover:text-blue-400 cursor-pointer transition-colors" />
            <SafeIcon icon={FiMail} className="text-xl text-gray-400 hover:text-blue-400 cursor-pointer transition-colors" />
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;